import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Terms() { return <StaticPageRedirect page="terms" />; }
